import { observable } from 'mobx';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface ITag {
    id: string;
    value: string;
    key: string;
}

export class Tag {
    @observable public id: string = '';
    @observable public value: string = '';
    @observable public key: string = '';

    public static fromJson(tag: ITag): Tag {
        const newTag = new Tag();
        if (tag) {
            copyPropertiesExcludeNullsAndGetters(newTag, tag);
        }

        return newTag;
    }
}
